import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=cd50e848&scoped=true&"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=cd50e848&lang=scss&scoped=true&"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./VerticalNavMenu.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd50e848",
  null
  
)

export default component.exports